import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import ErrorView from 'components/ErrorView'
import Spacer from 'components/Spacer'
import { useAppSelector } from 'state/hooks'
import { selectIsSubAccountMode } from 'state/wallet/selectors'

import ManageTab from './components/ManageTab'

const OneClickTradingTab: FC = () => {
	const { t } = useTranslation()

	const isSubAccountMode = useAppSelector(selectIsSubAccountMode)

	return (
		<>
			<Spacer height={20} />
			<ManageTab />
			{isSubAccountMode && (
				<ErrorView
					messageType="warn"
					message={t('futures.market.trade.confirmation.modal.disabled-delegation-trading')}
					containerStyle={{ margin: '16px 0 0 0' }}
				/>
			)}
		</>
	)
}

export default OneClickTradingTab
